// extracted by mini-css-extract-plugin
export default {"wrap":"ProductGroupsComponent_wrap__qxoWf","listBlock":"ProductGroupsComponent_listBlock__CwbQI","btnBlock":"ProductGroupsComponent_btnBlock__zkXuH"};